import React, { useEffect, useState } from 'react';
import measurementConfig from '../config/measurement';
import { readConsentChoice, updateConsent } from '../utils/analytics';

const OPEN_CONSENT_EVENT = 'open-consent-settings';

const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [advertising, setAdvertising] = useState(false);

  useEffect(() => {
    if (!measurementConfig.enabled && process.env.REACT_APP_TRAFFIC_ENABLED !== 'true') {
      return undefined;
    }

    setVisible(!readConsentChoice());
    const openSettings = () => {
      const choice = readConsentChoice();
      setAnalytics(choice?.analytics_storage === 'granted');
      setAdvertising(choice?.ad_storage === 'granted');
      setShowDetails(true);
      setVisible(true);
    };

    window.addEventListener(OPEN_CONSENT_EVENT, openSettings);
    return () => window.removeEventListener(OPEN_CONSENT_EVENT, openSettings);
  }, []);

  if (!visible) {
    return null;
  }

  const save = (selection) => {
    updateConsent(selection);
    setVisible(false);
    setShowDetails(false);
  };

  return (
    <section
      className="fixed inset-x-0 bottom-0 z-[70] border-t border-gray-200 bg-white shadow-[0_-8px_24px_rgba(0,0,0,0.12)]"
      aria-labelledby="consent-title"
    >
      <div className="container mx-auto px-4 py-5">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-3xl">
            <h2 id="consent-title" className="mb-2 text-xl font-bold text-gray-900">
              Gizlilik tercihleriniz
            </h2>
            <p className="text-sm leading-6 text-gray-600">
              İzin verirseniz sayfa görüntülemelerini ve telefon/WhatsApp bağlantısı
              tıklamalarını ölçeriz. Reklam izni ayrıca bu ölçümleri kampanya
              kimlikleriyle ilişkilendirir. Seçim yapmadan ölçüm depolaması açılmaz;
              siteyi izin vermeden de kullanabilirsiniz.{' '}
              <a href="/gizlilik" className="font-semibold text-primary underline">Gizlilik ve saklama bilgileri</a>.
              Tercihinizi daha sonra sayfa altından değiştirebilirsiniz.
            </p>

            {showDetails && (
              <div className="mt-4 grid gap-3 sm:grid-cols-3">
                <label className="flex items-start gap-3 rounded-xl border border-gray-200 p-3">
                  <input type="checkbox" checked disabled className="mt-1" />
                  <span>
                    <strong className="block text-sm text-gray-900">Zorunlu</strong>
                    <span className="text-xs text-gray-600">Site işlevleri ve tercih kaydı.</span>
                  </span>
                </label>
                <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-gray-200 p-3">
                  <input
                    type="checkbox"
                    checked={analytics}
                    onChange={(event) => setAnalytics(event.target.checked)}
                    className="mt-1"
                  />
                  <span>
                    <strong className="block text-sm text-gray-900">Kullanım ölçümü</strong>
                    <span className="text-xs text-gray-600">Sayfa, telefon ve WhatsApp bağlantısı tıklamaları.</span>
                  </span>
                </label>
                <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-gray-200 p-3">
                  <input
                    type="checkbox"
                    checked={advertising}
                    onChange={(event) => setAdvertising(event.target.checked)}
                    className="mt-1"
                  />
                  <span>
                    <strong className="block text-sm text-gray-900">Reklam</strong>
                    <span className="text-xs text-gray-600">Dönüşüm ve reklam ölçümü.</span>
                  </span>
                </label>
              </div>
            )}
          </div>

          <div className="flex flex-wrap gap-2 lg:max-w-sm lg:justify-end">
            <button
              type="button"
              onClick={() => save({ analytics: false, advertising: false })}
              className="rounded-xl border border-gray-300 px-4 py-2 font-semibold text-gray-700 hover:bg-gray-50"
            >
              Reddet
            </button>
            {showDetails ? (
              <button
                type="button"
                onClick={() => save({ analytics, advertising })}
                className="rounded-xl border border-primary px-4 py-2 font-semibold text-primary hover:bg-primary/5"
              >
                Tercihleri kaydet
              </button>
            ) : (
              <button
                type="button"
                onClick={() => setShowDetails(true)}
                className="rounded-xl border border-primary px-4 py-2 font-semibold text-primary hover:bg-primary/5"
              >
                Tercihler
              </button>
            )}
            <button
              type="button"
              onClick={() => save({ analytics: true, advertising: true })}
              className="rounded-xl border border-primary px-4 py-2 font-semibold text-primary hover:bg-primary/5"
            >
              Tümünü kabul et
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export { OPEN_CONSENT_EVENT };
export default ConsentBanner;
